'use strict';

var _regeneratorRuntime = require("/vercel/workpath0/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/wrapNativeSuper");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var AggregateError = require('aggregate-error');

var PCancelable = require('p-cancelable');

var FilterError = /*#__PURE__*/function (_Error) {
  _inherits(FilterError, _Error);

  var _super = _createSuper(FilterError);

  function FilterError() {
    _classCallCheck(this, FilterError);

    return _super.apply(this, arguments);
  }

  return FilterError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var pSome = function pSome(iterable, options) {
  return new PCancelable(function (resolve, reject, onCancel) {
    var count = options.count,
        _options$filter = options.filter,
        filter = _options$filter === void 0 ? function () {
      return true;
    } : _options$filter;

    if (!Number.isFinite(count)) {
      reject(new TypeError("Expected a finite number, got ".concat(typeof options.count)));
      return;
    }

    var values = [];
    var errors = [];
    var elementCount = 0;
    var isSettled = false;
    var completed = new Set();

    var maybeSettle = function maybeSettle() {
      if (values.length === count) {
        resolve(values);
        isSettled = true;
      }

      if (elementCount - errors.length < count) {
        reject(new AggregateError(errors));
        isSettled = true;
      }

      return isSettled;
    };

    var cancelPending = function cancelPending() {
      var _iterator = _createForOfIteratorHelper(iterable),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var promise = _step.value;

          if (!completed.has(promise) && typeof promise.cancel === 'function') {
            promise.cancel();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };

    onCancel(cancelPending);

    var _iterator2 = _createForOfIteratorHelper(iterable),
        _step2;

    try {
      var _loop = function _loop() {
        var element = _step2.value;
        elementCount++;

        _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var value;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return element;

                case 3:
                  value = _context.sent;

                  if (!isSettled) {
                    _context.next = 6;
                    break;
                  }

                  return _context.abrupt("return");

                case 6:
                  if (filter(value)) {
                    _context.next = 8;
                    break;
                  }

                  throw new FilterError('Value does not satisfy filter');

                case 8:
                  values.push(value);
                  _context.next = 14;
                  break;

                case 11:
                  _context.prev = 11;
                  _context.t0 = _context["catch"](0);
                  errors.push(_context.t0);

                case 14:
                  _context.prev = 14;
                  completed.add(element);

                  if (!isSettled && maybeSettle()) {
                    cancelPending();
                  }

                  return _context.finish(14);

                case 18:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 11, 14, 18]]);
        }))();
      };

      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    if (count > elementCount) {
      reject(new RangeError("Expected input to contain at least ".concat(options.count, " items, but contains ").concat(elementCount, " items")));
      cancelPending();
    }
  });
};

module.exports = pSome;
module.exports.AggregateError = AggregateError;
module.exports.FilterError = FilterError;